// extracted by mini-css-extract-plugin
export default {"btnWrap":"btnWrap__ADGai","btnActive":"btnActive__LfTAG","btnDisabled":"btnDisabled__xtKkI"};